import { CSSProperties, MouseEventHandler, ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost" | "accent" | "danger";
type Size = "sm" | "md";

type Props = {
  variant?: Variant;
  size?: Size;
  icon?: string;
  children?: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  style?: CSSProperties;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  title?: string;
};

const variants: Record<Variant, CSSProperties> = {
  primary: { background: "var(--brand-700)", color: "#fff", border: "1px solid var(--brand-700)" },
  secondary: { background: "var(--bg-card)", color: "var(--fg)", border: "1px solid var(--border-strong)" },
  ghost: { background: "transparent", color: "var(--fg-muted)", border: "1px solid transparent" },
  accent: { background: "var(--accent)", color: "#fff", border: "1px solid var(--accent)" },
  danger: { background: "transparent", color: "#b44a4a", border: "1px solid var(--border-strong)" },
};

export function Btn({
  variant = "primary",
  size = "md",
  icon,
  children,
  onClick,
  style,
  type = "button",
  disabled,
  title,
}: Props) {
  const base: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: size === "sm" ? "5px 10px" : "7px 14px",
    borderRadius: 8,
    cursor: disabled ? "default" : "pointer",
    fontSize: size === "sm" ? 12 : 13,
    fontWeight: 600,
    fontFamily: "var(--font-body)",
    transition: "background .12s ease, border-color .12s ease, color .12s ease",
    whiteSpace: "nowrap",
    opacity: disabled ? 0.55 : 1,
  };
  return (
    <button type={type} onClick={onClick} disabled={disabled} title={title} style={{ ...base, ...variants[variant], ...style }}>
      {icon && (
        <span className="material-icons-outlined" style={{ fontSize: size === "sm" ? 14 : 16 }}>
          {icon}
        </span>
      )}
      {children}
    </button>
  );
}
